import NarratorCommentary from './NarratorCommentary';

export { NarratorCommentary };
